import {Component} from 'react';
import axios from '../../axios-login';


class AuthUserToSF extends Component {
    static getSFToken(segment, successCallback, errorCallback) {
        //visionqa
            var userName = "";
            var password = "";

            if(segment === "SEGMENT_1") {
                userName = process.env.REACT_APP_SEGMENT_1_SF_USERNAME;
            } 
            else if(segment === "SEGMENT_2") {
                userName = process.env.REACT_APP_SEGMENT_2_SF_USERNAME;
            }  
            else if(segment === "SEGMENT_3") {
                userName = process.env.REACT_APP_SEGMENT_3_SF_USERNAME;
            } 
            else if(segment === "SEGMENT_4") {
                userName = process.env.REACT_APP_SEGMENT_4_SF_USERNAME;
            }

            if(userName.length === 0) {
                errorCallback("Something went wrong.");
            } else {
                var payload = {"Username":""+userName+"", "Password":""+password+"", "Org":""+ process.env.REACT_APP_ENV +""};
                axios.post("", JSON.stringify(payload))
                .then(response => {
                    if (response.data.status){
                        successCallback(response.data.access_token);
                    } else {
                        errorCallback("Something went wrong. Please contact city.");
                    }
                })
                .catch(error => {
                    errorCallback("Something went wrong.");
                })
        }
    }
}

export default AuthUserToSF;
